<template>
  <div v-if="holidayCalendar">
    <h1>Holiday calendar</h1>
    <v-layout row>
      <v-flex xs12 md6>
        <a @click="year = holidayCalendar.previousYear">{{holidayCalendar.previousYear}}</a>
        &#160;
        <span class="holidayYear">{{holidayCalendar.year}}</span>
        &#160;
        <a @click="year = holidayCalendar.nextYear">{{holidayCalendar.nextYear}}</a>
        &#160;
        <v-btn
          :to="{name:'holidayAdd'}"
          v-if="$keycloak.hasRealmRole('holidayadmin')"
          small
          color="success"
        >
          <v-icon>add</v-icon>Holiday
        </v-btn>
      </v-flex>
      <v-flex xs12 md6>
        <v-select
          label="Filter conveyancer"
          v-model="entityid"
          :items="entities"
          item-value="id"
          outline
        >
          <template slot="selection" slot-scope="data">{{ nameFormatted(data.item) }}</template>
          <template slot="item" slot-scope="data">{{ nameFormatted(data.item) }}</template>
          <template slot="append-outer" v-if="entityid">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <a @click="entityid = null" v-on="on">
                  <v-icon>clear</v-icon>
                </a>
              </template>
              <span>Clear filter</span>
            </v-tooltip>
          </template>
        </v-select>
      </v-flex>
    </v-layout>
    <table class="holidayCalendar">
      <tr>
        <th :colspan="holidayCalendar.max + 1" class="holidayCalendarYear">{{holidayCalendar.year}}</th>
      </tr>
      <tr
        v-for="holidayMonth in computedHolidayCalendar.holidayMonths"
        :key="holidayMonth.id"
        class="holidayCalendarRow"
      >
        <th class="holidayCalendarMonth">{{holidayMonth.name}}</th>
        <td
          v-for="holidayDay in holidayMonth.holidayDays"
          :key="holidayDay.id"
          :class="holidayDay.styleClass"
        >
          <div v-if="holidayDay.id != 0" class="holidayCalendarDay">{{holidayDay.id}}</div>
          <div v-for="holiday in holidayDay.holidays" :key="holiday.id">
            <HolidayEntity
              :entity="holiday.entity"
              :year="holidayCalendar.year"
              :holidayId="holiday.id"
              format="initials"
              v-if="holiday.entity"
            />
            <HolidayEntity
              :year="holidayCalendar.year"
              :holidayId="holiday.id"
              format="initials"
              v-if="!holiday.entity"
            />
            <span class="holidayCalendarHalf" v-if="!holiday.morning || !holiday.afternoon">&#189;</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HolidayEntity from "@/components/link/HolidayEntity";
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "HolidayCalendar",
  metaInfo() {
    return {
      title: "Holiday calendar",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { HolidayEntity },
  computed: {
    computedHolidayCalendar() {
      if (!this.holidayCalendar) {
        return undefined;
      }
      const holidayMonths = this.holidayCalendar.holidayMonths.map(m => {
        const holidayDays = m.holidayDays.map(d => {
          if (d.holidayids) {
            const holidays = d.holidayids.map(h => {
              const holiday = this.holidays ? this.holidays[h] : undefined;
              const entity =
                holiday && this.holidaysEntities
                  ? this.holidaysEntities[holiday.entityid]
                  : undefined;
              return { ...holiday, entity };
            });
            return { ...d, holidays };
          } else {
            return d;
          }
        });
        return { ...m, holidayDays };
      });
      const holidayCalendar = { ...this.holidayCalendar, holidayMonths };
      // console.log(holidayCalendar);
      return holidayCalendar;
    }
  },
  data() {
    return {
      entities: null,
      holidayCalendar: null,
      holidays: null,
      holidaysEntities: null,
      year: null,
      entityid: null
    };
  },
  methods: {
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/directory/types/2/entities`)
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        })
        .catch(() => {});
    },
    fetchCalendar() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/calendar`, {
          params: { year: this.year, entityid: this.entityid }
        })
        .then(response => {
          // console.log(response.data);
          this.holidayCalendar = response.data;
        })
        .catch(() => {});
    },
    fetchHolidays() {
      nbmlaw
        .get(`/cors/admin/directory/holidays`, {
          params: { year: this.year, entityid: this.entityid }
        })
        .then(response => {
          // console.log(response.data);
          this.holidays = response.data;
        })
        .catch(() => {});
    },
    fetchHolidaysEntities() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/entities`, {
          params: { year: this.year, entityid: this.entityid }
        })
        .then(response => {
          // console.log(response.data);
          this.holidaysEntities = response.data;
        })
        .catch(() => {});
    },
    nameFormatted(entity) {
      return nameFormatted(entity.name, "index");
    },
    update() {
      this.fetchEntities();
      this.fetchCalendar();
      this.fetchHolidays();
      this.fetchHolidaysEntities();
    }
  },
  watch: {
    year: {
      immediate: true,
      handler() {
        this.update();
      }
    },
    entityid: {
      handler() {
        this.update();
      }
    }
  }
};
</script>

<style scoped>
table.holidayCalendar {
  background: #dddddd;
  font-size: 0.6em;
  width: 100%;
}

.holidayCalendarRow {
  vertical-align: top;
}

.holidayCalendarWeekend {
  height: 80px;
  background: #cccccc;
  width: 2%;
}

.holidayCalendarToday {
  height: 80px;
  background: #ccffcc;
}

.holidayCalendarPad {
  background: #dddddd;
}

.holidayCalendarNormal {
  height: 80px;
  background: white;
  width: 3%;
}

.holidayCalendarMonth {
  background: #999999;
  color: white;
  width: 3%;
}

.holidayCalendarDay {
  color: gray;
}

.holidayCalendarYear {
  background: #999999;
  color: white;
  font-size: 2em;
}

.holidayCalendarPublic {
  height: 80px;
  background: #eeeeee;
  width: 3%;
  color: #cc9999;
}

.holidayCalendarHalf {
  color: green;
}

.holidayYear {
  font-size: 1.5em;
  font-weight: bold;
}

.holidayEntityCreated {
  font-size: 0.7em;
}
</style>
